import history from '../../../history'
import { useSelector } from 'react-redux'
import { Button, StatusIcon } from '../..'
import { defineMessages, useIntl } from 'react-intl'
import MarketSpotlightText from './MarketSpotlightText'
import { dispatchEvent } from '../../../helpers/tagManager'
import { OVERLAY_HELPERS } from '../../../constants/navigation'
import { ViewMarketSpotlight } from '../../../constants/trackingEvents'
import { selectCurrentMarketTemperatureIndex } from '../../../store/selectors/marketRecord'

import styles from './MarketSpotlightNavigator.module.scss'

export const MSG = defineMessages({
  seeWhy: {
    id: 'General.seeWhy',
    defaultMessage: 'See why',
  },
})

export interface MarketSpotlightNavigatorProps {
  locked: boolean
}

export const MarketSpotlightNavigator = ({
  locked,
}: MarketSpotlightNavigatorProps) => {
  const index = useSelector(selectCurrentMarketTemperatureIndex)
  const intl = useIntl()

  const handleClick = () => {
    if (!locked) {
      dispatchEvent(ViewMarketSpotlight)
      history.push(OVERLAY_HELPERS.marketSpotlight.buildPath())
    }
  }

  return (
    <div className={styles.wrapper}>
      {!index && <StatusIcon spin />}
      {index && (
        <>
          <MarketSpotlightText />
          <Button
            minimal
            onClick={handleClick}
            data-qa='take-a-look-btn'
            className={styles.moreDetails}
          >
            {intl.formatMessage(MSG.seeWhy)}
          </Button>
        </>
      )}
    </div>
  )
}
